import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const CustomGrid = styled.div(
  (props: { cols?: string; mt?: boolean; bp?: string; gap?: string }) => css`
    display: grid;
    grid-template-columns: ${props.cols ? props.cols : '1fr'};
    margin-top: ${props.mt ? '1em' : '0'};
    grid-gap: ${props.gap ? props.gap : '1em'};

    @media screen and (max-width: ${props.bp ? props.bp : bp.small}) {
      grid-template-columns: 1fr;
    }
  `
)

export const ModalActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1em;
`
